<template>
  <div>
    <section>
      <div class="section-container">
        <vs-select id="blueSpecies" v-model="selectedSpecie">
          <vs-select-item
            v-for="(specie, index) in species"
            :key="index"
            :value="specie"
            :text="specie.alias"
          />
        </vs-select>
        <div class="button">
          <vs-button
            type="filled"
            size="small"
            icon="dns"
            color="#19535F"
            @click="getAquacultureSuitabilities()"
            >Calculate Aquaculture Suitabilities</vs-button
          >
        </div>
      </div>
    </section>
    <section v-if="showResults" id="results">
      <vs-divider>
        Suitability for long-term (2070 – 2099) projection of RCP 8.5
      </vs-divider>
      <div class="grid-results">
        <div class="header-item">Biological</div>
        <div class="result-item">
          <vs-chip>
            <vs-avatar
              :icon="$_utilsMixin_getCategoryIcon(results.biological)"
              text
              class="index-avatar"
            />
            <span
              v-if="parsedResults.biological !== noDataValue"
              class="label-result"
              >{{ parsedResults.biological }}%</span
            >
            <span v-else class="label-result">No Data</span>
          </vs-chip>
          <span
            :style="{
              backgroundColor: $_utilsMixin_getCategoryColor(results.biological)
            }"
            class="dot"
          />
        </div>
      </div>
      <label class="footer-label">
        * Locations with depths higher than 700m are not considered suitable for
        aquaculture, the result is expresed as "No Data"
      </label>
    </section>
  </div>
</template>
<script>
import { SECTORS_FUTURE, NO_DATA_VALUE } from "@/constants.js";
import { getSuitability } from "@/api/thredds.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      aquacultureSector: SECTORS_FUTURE.aquaculture,
      noDataValue: NO_DATA_VALUE,
      selectedSpecie: {},
      species: [],
      showResults: false,
      results: {
        biological: 0
      }
    };
  },
  computed: {
    ...mapState("map", {
      marker: state => state.marker
    }),
    hasResults() {
      return this.results.length > 0;
    },
    parsedResults() {
      return {
        biological:
          this.results.biological >= 0
            ? parseInt(this.results.biological * 100)
            : NO_DATA_VALUE
      };
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadClimateChangeSpecies();
      this.selectedSpecie = this.species[0];
    },
    loadClimateChangeSpecies() {
      var sortedList = this.aquacultureSector.variables;
      this.species = sortedList.sort(this.$_utilsMixin_sortArray("alias"));
    },
    getAquacultureSuitabilities() {
      this.getBiologicalSuitability();
      this.showResults = true;
    },
    async getBiologicalSuitability() {
      const params = {
        point: this.marker,
        path: this.aquacultureSector.path,
        variableName: this.selectedSpecie.shortName
      };
      try {
        const bioSuitability = await getSuitability(params);
        this.results.biological = parseFloat(bioSuitability);
      } catch (e) {
        this.results.biological = -999;
        this.$_utilsMixin_notify(
          "Error calculating suitability",
          e.response.data,
          2
        );
      }
    }
  }
};
</script>
<style scoped>
.grid-results {
  display: grid;
  grid-template-columns: 1fr;
  /* grid-template-rows: 9rem 1fr 0.4fr 1rem; */
  grid-template-rows: 20px 1fr;
  grid-gap: 1rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
}

.header-item {
  font-size: 1rem;
  font-weight: bold;
}

.result-item {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: center;
}

.button {
  display: flex;
  justify-content: flex-end;
}
.label-result {
  font-size: 1.4rem;
  margin-right: 5px;
}
</style>
